module.exports = __webpack_public_path__ + "static/pointOfSale-c72a7495f206f7fab1ffc523eab31bef.jpg";